import { diYu } from './common-var'

const fieldsBasic = {
  长期意向: {
    label: '长期意向',
    width: '24%',
    type: 'color',
    options: {
      Y: { word: 'Y.积极看机会', color: '#f99' },
      N: { word: 'N.暂时不看机会', color: '#ffc' },
      F: { word: 'F.再跟进', color: '#ccf' },
    },
  },
  姓名: {
    label: '姓名',
    width: '24%',
    isRequired: true,
  },
  英文名: {
    label: '英文名',
    width: '24%',
  },
  手机: {
    label: '手机',
    width: '24%',
  },
  性别: {
    label: '性别',
    width: '24%',
    type: 'select',
    options: ['男', '女', ''],
  },
  婚育: {
    label: '婚育',
    width: '24%',
    type: 'select',
    options: ['未婚', '已婚未育', '已婚已育', '其他', ''],
  },
  籍贯: {
    label: '籍贯',
    width: '24%',
  },
  职能模块: {
    label: '职能模块',
    width: '24%',
    type: 'multSelect',
    options: [],
  },
  细分职能: {
    label: '细分职能',
    width: '24%',
    type: 'createSelect',
    option: [],
  },
  擅长方向: {
    label: '擅长方向',
    width: '24%',
    type: 'multSelect',
    option: [],
  },
  个性标签: {
    label: '个性标签',
    width: '24%',
  },
  职级: {
    label: '职级',
    width: '24%',
    type: 'select',
    options: {
      '1': '1.高管',
      '2': '2.部门总',
      '3': '3.部门副总/总助/团队长',
      '4': '4.部门核心骨干',
      '5': '5.新人三年以下',
      '': '--',
    },
  },
  业绩: {
    label: '业绩',
    width: '24%',
    type: 'select',
    options: {
      aaa: 'aaa.领军人物',
      aa: 'aa.卓越人选',
      a: 'a.优秀人选',
      b: 'b.良好',
      c: 'c.一般',
      d: 'd.较差',
      '': '--',
    },
  },
  平台: {
    label: '平台',
    width: '24%',
    type: 'select',
    options: {
      A: 'A.大平台',
      B: 'B.中平台',
      C: 'C.小平台',
      '': '--',
    },
  },
  地域: {
    label: '地域',
    width: '24%',
    type: 'createSelect',
    options: diYu,
  },
  公司: {
    label: '公司',
    width: '24%',
  },
  曾任职公司: {
    label: '曾任职公司',
    width: '24%',
  },
  部门: {
    label: '部门',
    width: '24%',
  },
  组别: {
    label: '组别',
    width: '24%',
  },
  目前职位: {
    label: '目前职位',
    width: '24%',
  },
  专业职级: {
    label: '专业职级',
    width: '24%',
    type: 'autocomplete',
    options: ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN', ''],
  },
  管理职级: {
    label: '管理职级',
    width: '24%',
    type: 'autocomplete',
    options: [
      '公司总经理',
      '公司副总',
      '公司总助',
      '一级部门总',
      '二级部门总',
      '部门副总',
      '部门总助',
      '总监',
      '副总监',
      '经理',
      '主管',
      '专员',
    ],
  },
  薪酬机制: {
    label: '薪酬机制',
    width: '24%',
  },
  本科院校: {
    label: '本科院校',
    width: '24%',
  },
  硕士院校: {
    label: '硕士院校',
    width: '24%',
  },
  学历: {
    label: '学历',
    width: '24%',
    type: 'select',
    options: ['中专', '大专', '本科', '硕士', '博士', '博士后', ''],
  },
  下属个数: {
    label: '下属个数',
    width: '24%',
  },
  汇报上级: {
    label: '汇报上级',
    width: '24%',
  },
  行业: {
    label: '行业',
    width: '24%',
    type: 'select',
    options: [],
  },
  出生年月: {
    label: '出生年月',
    width: '24%',
    displayLabel: '例:1980.01',
    // type: 'month'
  },
  从业起始年: {
    label: '从业起始年',
    width: '24%',
  },
  规模: {
    label: '规模',
    width: '24%',
  },
  管理基金数量: {
    label: '管理基金数量',
    width: '24%',
  },
  任职期: {
    label: '任职期',
    width: '24%',
  },
  管理基金: {
    label: '管理基金',
    width: '24%',
  },
  投资风格: {
    label: '投资风格',
    type: 'select',
    options: ['GARP型', '价值型', '成长型', '极致成长型', '综合型', ''],
    width: '24%',
  },
  简介: {
    label: '简介',
    width: '100%',
    type: 'textarea',
  },
  获奖经历: {
    label: '获奖经历',
    width: '32%',
    type: 'multSelect',
    options: ['新财富', '金牛奖', '水晶球', '麒麟奖', '英华奖'],
  },
  香港牌照: {
    label: '香港牌照',
    width: '24%',
    type: 'multSelect',
    options: [
      '证券交易',
      '期货合约交易',
      '杠杆式外汇交易',
      '就证券提供意见',
      '就期货合约提供意见',
      '就机构融资提供意见',
      '提供自动化交易服务',
      '提供证券保证金融资',
      '提供资产管理',
      '提供信贷评级服务',
    ],
  },
  邮箱: {
    label: '邮箱',
    width: '24%',
  },
  座机: {
    label: '座机',
    width: '24%',
  },
  微信: {
    label: '微信',
    width: '24%',
  },
  其他: {
    label: '其他',
    width: '24%',
  },
}
const fieldsQi = {
  期望行业: {
    label: '期望行业',
    width: '49%',
    type: 'multSelect',
    options: [],
  },
  期望地域: {
    label: '期望地域',
    width: '49%',
    type: 'createSelect',
    options: diYu,
  },
  期望固薪: {
    label: '期望固薪',
    width: '49%',
  },
  期望奖金: {
    label: '期望奖金',
    width: '49%',
  },
}
export { fieldsBasic, fieldsQi }
